import moment from 'moment';
import { DateObject } from 'react-multi-date-picker';

export const verifyAllChecked = (horariosOptions) => {
  return horariosOptions.slice(1).every(h => h.checked);
}

export const countChecked = (horariosOptions) => {
  return horariosOptions?.slice(1).filter(h => h.checked).length;
}

export const  generateObject = ({ 
  horariosOptions, 
  operation, 
  dataInicial, 
  dataFinal,
  duracao,
  datas,
  convenios
}) => {
  const periodos = [];
  const allOptionsChecked = horariosOptions[0].checked;
  const daysInRange = getDaysInRange(dataInicial, dataFinal);

  const horariosChecked = horariosOptions.filter(h => h.checked);
  const conveniosToSave = convenios?.length > 0 ? convenios.map(c => ({ id: c.value })) : null;


  if (datas?.length > 0) {
    try {
      var horariosSelecionados = horariosChecked.filter((horario) => {
        return horario.checked;
      });

      if (allOptionsChecked) {
        datas.map((data) => {
          return periodos.push({
            acao: operation,
            data: new DateObject(data).format("YYYY-MM-DD"),
            horaInicio: "00:00",
            horaFim: "23:59",
            ...(conveniosToSave && { convenios: conveniosToSave }),
          });
        });
      } else {
        datas.map((data) => {
          horariosSelecionados.map((horario) => {
            return periodos.push({
              acao: operation,
              data: new DateObject(data).format("YYYY-MM-DD"),
              horaInicio: horario.value,
              horaFim: moment(horario.value, "HH:mm")
                .add(duracao, "minutes")
                .format("HH:mm"),
              ...(conveniosToSave && { convenios: conveniosToSave }),
            });
          });
        });
      }

      return periodos;
    } catch (e) {
      console.error(e);
    }
  }

  if (allOptionsChecked) {
    daysInRange.forEach(day => {
      return periodos.push({
        acao: operation,
        data: day,
        horaInicio: "00:00",
        horaFim: "23:59",
        ...(conveniosToSave && { convenios: conveniosToSave }),
      })
    });
  } else {
    daysInRange.forEach(day => {
      horariosOptions.forEach(horario => {
        if (horario.checked) {
          return periodos.push({
            acao: operation,
            data: day,
            horaInicio: horario.value,
            horaFim: moment(horario.value, 'HH:mm').add(duracao, 'minutes').format('HH:mm'),
            ...(conveniosToSave && { convenios: conveniosToSave }),
          });
        }
      });
    });
  }
  return periodos;
}

const getDaysInRange = (dataInicial, dataFinal) => {
  const days = [];
  const startDate = moment(dataInicial);
  const endDate = moment(dataFinal);
  while (startDate <= endDate) {
    days.push(startDate.format('YYYY-MM-DD'));
    startDate.add(1, 'days');
  }
  return days;
}